;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputNumber', inputNumber)

  /* @ngInject */
  function inputNumber () {
    return {
      restrict: 'EA',
      scope: {
        label: '@',
        description: '@',
        modelPropertyName: '@',
        model: '=',
        value: '<',
        maxValue: '@',
        minValue: '@',
        disabled: '<',
        readOnly: '<',
        mandatory: '<',
        change: '=',
        placeholder: '@'
      },
      templateUrl: '/core/directives/input-number/input-number-directive.html?$$REVISION$$',
      controller: 'InputNumberController'
    }
  }
})()
